import firebaseDB from '@src/firebase/database';
import { types, actions } from '../index';
import { selectCurrentProfile,selectSubscriberId, selectSubscriberEmail, selectCommonAnalytics, selectConfiguration } from '../selectors';
import { fetchContent, fetchContentCount } from '@src/apis/Contents';
import { statusEnums } from '@src/consts';
import hitRuleEngineApi from '@src/apis/RuleApi';
import { processNodeToList, notZero } from '@src/utils/helpers';
import analytics from '@src/firebase/analytics';
import { sendMobioticsAnalytics, nowtoDateConversion } from "@src/utils/helpers";


const FirebaseEffects = (store, action) => {
  switch (action.type) {
    case types.firebase.SetLevel:
      store.dispatch( actions.rewards.ClearAll() );
      
      setProfileValue( store, '' + action.payload, {
        path: '/levels/current',
        key: 'currentLevel'
      })
      break;
    case types.firebase.SetOnboard:
      setProfileValue( store, '' + action.payload, {
        path: '/levels/onboard',
        key: 'onboardLevel'
      })
      break;
    case types.firebase.SetLesson:
      setLesson(store, action.payload);
      break;
    case types.firebase.SetDisabledCourses:
      setDisabledCourses(store, action.payload);
      break;
    case types.firebase.SetDisabledLevels:
      setDisabledLevels(store, action.payload);
      break;
    case types.firebase.SetFireAvatar:
      setCurrentAvatar(store, action.payload);
      break;
    case types.firebase.setAvatarEvent:
      unlockNewAvtarEvent(store, action.payload)
      break;
    case types.firebase.SetParentConsent:
      setParentConsent(store, action.payload);
      break;
    case types.firebase.SetTimer:
      setProfileValue( store, action.payload, {
        path: '/timecontrol',
        key: 'timerData'
      });
      break;
    case types.firebase.SetBrowsingMode:
      setProfileValue(store, action.payload, { 
          path: '/browsingmodeenabled', 
          key: 'browsingmode' 
        } );
      break;
    case types.firebase.SendEventData :
      fireEventApi( store, action.payload );
      break;
    case types.firebase.SendGame :
      sendGameResult( store, action.payload ); 
      break;
    default:
      return null;
    //case types.SetLevel : lessonUpdate( store, action.payload ); break;
  }
};

function fireEventApi( store, { eventtype, eventdata } ){
  if( !eventtype || !eventdata )return console.warn( 'wrong event data' );

  const profile = selectCurrentProfile( store.getState() );

  const ruleData = {
    profileid : profile.profileid,
    profilename : profile.name,
    email: selectSubscriberEmail( store.getState() ),
    eventtype,
    eventdata: eventdata 
  }

  hitRuleEngineApi( ruleData );
}

async function sendGameResult( store, { content, data,dataMilestone, ...args } ){
    if( content.assessment )return ;
    const assessment = {} ;
    const MilestoneName = dataMilestone && dataMilestone?.success || "";
    const total = data?.right + data?.wrong;
    let score = data?.right/notZero(total);
    let outcome = 'Needs Practice'; 
    if (score >=0.5) outcome = 'Progressing' ; 
    if(score === 1) outcome = 'Excellent'
    assessment.gameassessment = {
      gamename : data.game ,
      updatedat: Date.now(),
      right: data.right,
      wrong: data.wrong,
      questionscount: data.levels,
      retries: data.retries,
      status: 'COMPLETED',
      milestone:MilestoneName,
      outcome:outcome
    }
    const profile = selectCurrentProfile( store.getState() );
    const commonAnalytics = selectCommonAnalytics( store.getState() );  
    const path = `/${profile.profileid}/levels/${profile.currentLevel}/content/${content.seriesid}/lessons/${content.contentid}`;
    store.dispatch(actions.stories.UpdateStories({ contents : [ {
      ...content,
      assessment
    } ] }));
    
    await firebaseDB.getSubscriberPath().ref( path ).update( { assessment } );

    const gamecountPath = `/${profile.profileid}/levels/${profile.currentLevel}/content/${content.seriesid}/progress`;

    const progressData = await firebaseDB.getSubscriberPath().ref( gamecountPath ).get();

    const completedGames = progressData.completedgames ?? 0

    await firebaseDB.getSubscriberPath().ref( gamecountPath ).update( { 'completedgames': completedGames+1 } );

    const ruleData = {
      eventtype: 'GAMEASSESMENT', 
      eventdata: {
        assesmentcompletion:true,
        contentid: content.contentid,
        courseid: content.seriesid 
      }
    }
    store.dispatch( actions.firebase.SendEventData( ruleData ) );
    analytics.logEvent( 'GAME', { ...commonAnalytics , ...{ GameTitle: data.game , GameID:content.contentid, Category:content.seriestitle, NoOfAttempt: data.attempts , NoofQuestions: data.levels, NoofRetry: data.retries, Result:'Success', ErrorCode: '', ErrorMessage: '' ,CourseID: content.contentid, CourseTitle:content.title }} );

}


function setProfileValue( store, payload, { path = null, key = '' } ){
  
  const currentProfile = selectCurrentProfile( store.getState() );

  if( !currentProfile ) return ;

  const profileid = currentProfile.profileid ;

  store.dispatch( actions.profile.SetLocalProfile({ profileid, [ key ] : payload } ) );

  if( !path )return ;
  //Add to firebase
  const nodepath = `/${ profileid }` + path ;
  firebaseDB.getSubscriberPath().ref( nodepath ).set( payload );
}

async function setLesson(store, { profile, content, gameCount }) {
  if( profile.browsingmode )return ; //no firebase update on browsing mode.
  const paths = {};
  paths.level = `/${profile.profileid}/levels/${profile.currentLevel}` ;
  paths.lesson = `${ paths.level }/content/${content.seriesid}/lessons/${content.contentid}`;
  paths.course = `${ paths.level }/content/${content.seriesid}`;
  
  //mutations:
  content.videocompletion = Math.trunc( content.watchedduration * 100 / content.duration );
  content.completed = content.iscompletedonce || content.videocompletion >= 85 ; 

  //declarations:
  const now = Date.now();
  let ruleData = null ;

  let courseFire = await firebaseDB.getSubscriberPath().ref( paths.course ).get();

  courseFire = courseFire ?? {};
  courseFire.lessons = courseFire.lessons ?? {};
  const lessonFire = courseFire.lessons[content.contentid] ?? null;

/** assign rule engine data */
  if( ( !lessonFire?.iscompletedonce ) && content.completed ) ruleData = {
        eventtype : 'VIDEOWATCH',
        eventdata : {
          courseid: content.seriesid,
          contentid : content.contentid,
          videocompletion: content.videocompletion
        }     
  }
/** assign rule engine data */

  const lessonData = {
    category: content.category ?? null,
    contenttitle: content.title ?? null,
    contenttype: content.contenttype ?? null,
    poster: content.imageUrl ?? null,
    duration: content.duration ?? null,
    watchedduration: content.watchedduration ?? null,

    completedat: lessonFire?.completedat ?? content.completed ? now : null,
    iscompletedonce: lessonFire?.iscompletedonce || content.completed || false,
    startedat: lessonFire?.startedat ?? now,
    status: content.completed ? statusEnums.completed : statusEnums.inprogress,
  };
  //mobiotics analytics
  const watchingtime = lessonFire?.watchedduration ? Math.abs(content.watchedduration - lessonFire?.watchedduration) : (content.watchedduration*1);
  const analyticsMobiData = [
    {
      Event:'contentwatchtime',
      ContentID: content.contentid,
      WatchingTime: watchingtime
    }
  ]

  const contentwatchanalyticsMobiData = [{
    Event:'contentview',
    ContentID: content.contentid,
    ViewCount: 1,
    SubscriberID: selectSubscriberId( store.getState() )
  }]
  
//  console.log('watchtime:',analyticsMobiData)
//  console.log('content:watchtime:',contentwatchanalyticsMobiData)

  const configuration = selectConfiguration( store.getState() );

  const contents = [{ contentid: content.contentid, ...lessonData }];

  store.dispatch(actions.stories.UpdateStories({ contents }));

  await firebaseDB.getSubscriberPath().ref( paths.lesson ).update(lessonData);

  courseFire.lessons[content.contentid] = lessonData;

  await batchCourse(store, { profile, content, paths, courseFire, ruleData, gameCount, configuration });
  batchLevelProgress( { profile, paths, courseFire} );

  sendMobioticsAnalytics(analyticsMobiData, configuration);
  sendMobioticsAnalytics(contentwatchanalyticsMobiData, configuration);

}

async function batchCourse(store, { content, paths, courseFire, ruleData, gameCount, configuration }) {
  const now = Date.now();

  let courseData = {};

  if (!courseFire?.progress) {
    const course = await fetchContent({ contentid: content.seriesid });
    courseData = {
      category: course.category ?? null,
      contenttitle: course.title ?? null,
      contenttype: course.contenttype ?? null,
      iscompletedonce: false,
      poster: course.imageUrl ?? null,
      startedat: now,
      updatedat: now,
    };
  }
  const totalLessons = await fetchContentCount( { seriesid: content.seriesid } );
  
  breakme: if ( totalLessons ){
      const completed = courseFire.lessons
      ? Object.values(courseFire.lessons).filter(
          (lesson) => lesson.status === statusEnums.completed
        ).length
      : 0;
      const completedGames = courseFire.lessons
      ? Object.values(courseFire.lessons).filter(
          (lesson) => lesson?.assessment?.gameassessment)?.length : 0;
      // console.log('totalgames:', gameCount, completedGames)
      courseData.progress = {
        total: totalLessons,
        completed,
        totalgames: gameCount,
        completedgames: completedGames
      };
      courseData.status =
        courseData.progress.total === courseData.progress.completed
          ? statusEnums.completed
          : statusEnums.inprogress;

      if (courseData.status === statusEnums.completed) {
        courseData.completedat = courseFire?.completedat ?? now;
        courseData.iscompletedonce = true;
      }
      if( courseFire?.progress && ( courseData.status !== statusEnums.completed ) )break breakme ;
      /** analytics course start */
      const profile = selectCurrentProfile( store.getState() );
      const email = selectSubscriberEmail( store.getState() );
      const commonAnalytics = selectCommonAnalytics( store.getState() );
        let analyticsdata = {
          Status: courseData.status === "COMPLETED" ? "COMPLETED" : "STARTED",
          CourseID: content.seriesid,
          CourseTitle: courseFire?.contenttitle ?? courseData.contenttitle,
          Category: courseFire?.category ?? courseData.category,
          progress: Math.round( courseData.progress.completed * 100 / courseData.progress.total ),
  
        }
        analyticsdata = {...analyticsdata, ...commonAnalytics}
        analytics.logEvent( "COURSE", {...analyticsdata} )
      /** analytics course end */
  }

  const contents = [{ contentid: content.seriesid, ...courseData }];

  store.dispatch(actions.course.UpdateCourses({ contents }));

  await firebaseDB.getSubscriberPath().ref( paths.course ).update(courseData);

  /** invoke mobi analytics */
  const getUnixTime = courseFire?.startedat ?? now;
 
  const courseprogressanalyticsMobiData = [{
    Event:'CourseProgress',
    ContentID: content.seriesid,
    StartDate: nowtoDateConversion(getUnixTime),
    SubscriberID: selectSubscriberId( store.getState() ),
    Status: courseData.status
  }]

//  console.log('get unix:', courseprogressanalyticsMobiData)
 sendMobioticsAnalytics(courseprogressanalyticsMobiData, configuration);
  /** invoke rule engine */

  ruleData && store.dispatch( actions.firebase.SendEventData( ruleData ) );

  /** invoke rule engine */
  
}

async function batchLevelProgress( {  profile, paths } ){

  const totalCourses = await fetchContentCount( { level: profile.currentLevel, contenttype : 'COURSE' } );

  if( !totalCourses ) return ;

  const contentPath = paths.level + '/content' ;

  let courseData = await firebaseDB.getSubscriberPath().ref( contentPath ).get() ;


  let courseList = processNodeToList( courseData, 'contentid' );

  const progress = {
    completed: courseList.filter( course => course.iscompletedonce ).length,
    total: totalCourses
  }

  const progressPath = paths.level + '/progress' ;

  firebaseDB.getSubscriberPath().ref( progressPath ).update( progress );
}

function setDisabledCourses(
  store,
  { path, profile, disabledCourses, effects = true }
) {
  store.dispatch(
    actions.course.SetDisabledCourses({ profile, disabledCourses })
  );

  if (!effects) return;

  firebaseDB.getSubscriberPath().ref(path).set(disabledCourses);
}

function setDisabledLevels(
  store,
  { path, profile, disabledLevels, effects = true }
) {
  store.dispatch(
    actions.profile.SetDisabledLevels({ profile, disabledLevels })
  );

  if (!effects) return;

  firebaseDB.getSubscriberPath().ref(path).set(disabledLevels);
}

function setCurrentAvatar(store, payload) {
  const { castncrewid } = payload;

  const currentProfile = selectCurrentProfile( store.getState() );

  const profileid = currentProfile?.profileid ;

  if( !profileid )return ;

  store.dispatch(actions.avatars.SetCurrent({ avatarid: castncrewid }));
  store.dispatch( actions.profile.UpdateProfileAvatar( { profile : {profileid:currentProfile.profileid,avatarid: castncrewid}} ))

  //Add to firebase
  const path = `/${ profileid }/avatar/current`;

  (castncrewid === 'fallback-profile-id') ? firebaseDB.getSubscriberPath().ref( path ).set( null ) : firebaseDB.getSubscriberPath().ref( path ).set( castncrewid )
 
}

// function setGamePlaying(store, payload) {
//  const  {isgamePlaying} = payload
//   console.log(isgamePlaying);
//   store.dispatch(actions.avatars.SetGameStatus({ isgamePlaying }));

// }

async function unlockNewAvtarEvent(store, payload){
   const { castncrewid, mode } = payload;
   let ruleData = null

   if(castncrewid && mode === 'LOCKED') ruleData = {
    eventtype : 'SELECTAVATAR',
    eventdata : {
      avatarid : castncrewid
    }
  }

  ruleData && store.dispatch( actions.firebase.SendEventData( ruleData ) );

}


function setParentConsent(
  store,
  { profile, gotparentconsent, effects = true }
) {
  const { currentLevel, profileid } = profile;

  if (!effects) return;

  const path = `/${profileid}/levels/${+currentLevel - 1}/gotparentconsent`;
  firebaseDB.getSubscriberPath().ref(path).set(gotparentconsent);
}


export { FirebaseEffects };
